import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { Box, Button } from "@mui/material";
import { t } from "i18next";
import { useCallback, useRef, useState, type FC } from "react";
import { usePopover } from "../../../../../../utils/hooks/use-popover";
import { ColourPicker } from "../../../../../generic/components/colour-picker/colour-picker";
import type { DataTableNode } from "../../../nodes/data-table-node";
import { SET_DATA_TABLE_BACKGROUND_COLOUR_COMMAND } from "../../../types/commands";

export const DataTableBackgroundColour: FC<{
  tableNode: DataTableNode;
}> = ({ tableNode }) => {
  const [editor] = useLexicalComposerContext();
  const [colour, setTempColour] = useState<string>(tableNode.getBackgroundColor());
  const popover = usePopover<HTMLButtonElement>();
  const popoverInputRef = useRef<HTMLInputElement>(null);

  const setColour = useCallback(
    (c: string) => {
      editor.dispatchCommand(SET_DATA_TABLE_BACKGROUND_COLOUR_COMMAND, {
        nodeKey: tableNode.getKey(),
        colour: c,
      });
      setTempColour(c || "");
    },
    [editor, tableNode],
  );

  return (
    <>
      <Button
        data-analytics-id="lexical-table-menu-background-colour"
        // eslint-disable-next-line react-hooks/refs
        ref={popover.anchorRef}
        // eslint-disable-next-line react-hooks/refs
        onClick={popover.handleToggle}
        sx={{ color: "text.secondary" }}
        endIcon={
          <Box
            sx={{
              p: 0,
              border: "1px solid #E0E0E0",
              backgroundColor: colour,
              width: 20,
              height: 20,
            }}
          ></Box>
        }
      >
        {t("Table background colour")}
      </Button>

      <ColourPicker
        // eslint-disable-next-line react-hooks/refs
        popover={popover}
        colour={colour}
        onInput={setColour}
        onChange={setColour}
        inputRef={popoverInputRef}
      />
    </>
  );
};
